import { Autocomplete, Button, Input } from "src/components";
import crossIcon from "src/assets/cross.svg";
import { useToast } from "src/hooks/useToast";
import { useState } from "react";
import { RootState } from "src/context/store";
import { useDispatch, useSelector } from "react-redux";
import { updateCashDiscount, getOrderDetailsByOrderCode } from "src/services/order-api";
import { useEventStatus } from "src/hooks/useEventStatus";
import { ordActions } from "src/context/order-slice";

const CashDiscountChange = ({ onCloseModal }: { onCloseModal: () => void }) => {
  const [updateInCorp, setUpdateInCorp] = useState<boolean>(false);
  const { orderDetailsFiltered } = useSelector((state: RootState) => state.ord);
  const [cashDiscount, setCashDiscount] = useState<string>(orderDetailsFiltered?.[0]?.order_cash_discount_perc);
  const { toast } = useToast();
  const { withEventCheck } = useEventStatus();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const changeCashDiscount = async () => {
    const payload = {
      data: { order_id: Number(orderDetailsFiltered?.[0]?.order_id_int), cash_discount: Number(cashDiscount), is_corp_update: updateInCorp },
      primary_key: Number(orderDetailsFiltered?.[0]?.order_id_int),
      event_type: "UPDATE_CASH_DISCOUNT",
    };

    try {
      setIsLoading(true);
      const response = await updateCashDiscount(payload);
      const response2 = await withEventCheck(
        () => {
          return getOrderDetailsByOrderCode(orderDetailsFiltered?.[0]?.order_code);
        },
        response?.data?.data?.eventStreamCreated?.streamId
      );
      dispatch(ordActions.setOrderDetailsFiltered([response2?.data?.data]));
      toast({ description: "Cash discount updated successfully", variant: "default" });
      onCloseModal();
    } catch (error: any) {
      toast({ description: error?.response?.data?.message, variant: "destructive" });
    } finally {
      setIsLoading(false);
      onCloseModal();
    }
  };

  return (
    <div className="flex flex-col gap-y-2 mb-4 w-[340px] max-h-[318px] mx-auto px-6 bg-white p-4 rounded-xl">
      <div className="flex justify-between items-center">
        <p className="text-normal py-1 font-semibold text-[#49484C]">Change Cash Discount</p>
        <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
          <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
        </Button>
      </div>

      <div>
        <p className="text-sm mb-2 mt-2 font-normal text-[#666666]">Cash Discount</p>
        {/* <p className="text-sm text-[#616161]">Invoice No</p> */}
        <Input
          type="text"
          placeholder="Enter Cash Discount"
          value={cashDiscount}
          onChange={(e) => setCashDiscount(e.target.value)}
          className="w-full border py-4 border-[#D0D0D0] rounded-md p-2 h-8"
        />
      </div>
      <p className="text-sm mb-2 mt-2 font-normal text-[#666666]">
        Update in Corp
        <Autocomplete
          inputClassName="w-full border py-4 border-[#D0D0D0] rounded-md p-2 mt-2 flex items-center h-8"
          placeholder="Select"
          suggestionList={[
            { name: "Yes", value: true },
            { name: "No", value: false },
          ]}
          displayKey="name"
          uniqueKey="value"
          onSelectionChange={(e: any) => setUpdateInCorp(e?.value)}
        />
      </p>

      <Button isLoading={isLoading} loaderSize="small" className="text-white bg-[#8051FF] mt-2" onClick={changeCashDiscount}>
        Save Changes
      </Button>
    </div>
  );
};

export default CashDiscountChange;
